import { render, staticRenderFns } from "./CrowdfundingPage.vue?vue&type=template&id=f058f7e6&scoped=true"
import script from "./CrowdfundingPage.vue?vue&type=script&lang=js"
export * from "./CrowdfundingPage.vue?vue&type=script&lang=js"
import style0 from "./CrowdfundingPage.vue?vue&type=style&index=0&id=f058f7e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f058f7e6",
  null
  
)

export default component.exports